import { render, staticRenderFns } from "./guide-card.vue?vue&type=template&id=1e616b50&scoped=true&"
import script from "./guide-card.vue?vue&type=script&lang=js&"
export * from "./guide-card.vue?vue&type=script&lang=js&"
import style0 from "./guide-card.vue?vue&type=style&index=0&id=1e616b50&lang=scss&scoped=true&"
import style1 from "./guide-card.vue?vue&type=style&index=1&id=1e616b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e616b50",
  null
  
)

export default component.exports
import {QCard,QCardSection,QAvatar,QImg,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QAvatar,QImg,QIcon})
